<template>
    <div id="holdings-table" class="AFIS-table">
        <div class="table-nav">
            <div
                :class="getFirstRow > 0 ? '' : 'hidden-buttons'"
                class="nav-buttons"
            >
                <button class="start-end-button" @click="paginationNav('first')">
                    <i class="icon icon-left-carrot" />
                    <i class="icon icon-left-carrot" />
                </button>
                <button class="prev-next-button" @click="paginationNav('prev')">
                    <i class="icon icon-left-carrot" />
                </button>
            </div>
            <span class="paging-info">
                <span v-show="getTotalNumberOfResults > getNumberOfResultsRequested">
                    {{ getSelectedFilter }} Holdings: {{ getFirstRow + 1 }} - {{ isAtHighestEnd(getFirstRow, getNumberOfResultsRequested) }} of {{ getTotalNumberOfResults }}
                </span>
                <span v-show="getTotalNumberOfResults <= getNumberOfResultsRequested && dataLength > 0">
                    {{ getSelectedFilter }} Holdings: 1 - {{ dataLength }} of {{ getTotalNumberOfResults }}
                </span>
                <span v-show="holdingsMetaData.totalFilterCount === 0">
                    {{ getSelectedFilter }} Holdings: 0 - 0 of 0
                </span>
            </span>
            <div
                :class="getFirstRow + getNumberOfResultsRequested < getTotalNumberOfResults ? '' : 'hidden-buttons'"
                class="nav-buttons"
            >
                <button class="prev-next-button" @click="paginationNav('next')">
                    <i class="icon icon-right-carrot" />
                </button>
                <button class="start-end-button" @click="paginationNav('last')">
                    <i class="icon icon-right-carrot" />
                    <i class="icon icon-right-carrot" />
                </button>
            </div>
        </div>
        <div id="table-wrapper">
            <div v-if="isLoading" id="quarterly-holdings-loading-gif" />
            <table :class="{ loading: isLoading }">
                <thead>
                    <tr>
                        <th>
                            <div class="button-container">
                                <button :class="{ activeSort: sortByLabel === 'holdings' }" @click="sortBy('holdings')">
                                    Security Name
                                </button>
                                <i
                                    v-show="sortByLabel === 'holdings'"
                                    class="icon"
                                    :class="reverse ? 'icon-down-carrot' : 'icon-up-carrot'"
                                />
                            </div>
                        </th>
                        <th>
                            Asset Type
                        </th>
                        <th>
                            <div class="button-container">
                                <button :class="{ activeSort: sortByLabel === 'shares' }" @click="sortBy('shares')">
                                    Shares or <br> Principal Amount
                                </button>
                                <i
                                    v-show="sortByLabel === 'shares'"
                                    class="icon"
                                    :class="reverse ? 'icon-down-carrot' : 'icon-up-carrot'"
                                />
                            </div>
                        </th>
                        <th>
                            <div class="button-container">
                                <button :class="{ activeSort: sortByLabel === 'marketValue' }" @click="sortBy('marketValue')">
                                    Market Value
                                </button>
                                <i
                                    v-show="sortByLabel === 'marketValue'"
                                    class="icon"
                                    :class="reverse ? 'icon-down-carrot' : 'icon-up-carrot'"
                                />
                            </div>
                        </th>
                        <th>
                            <div class="button-container">
                                <button :class="{ activeSort: sortByLabel === 'pctNetAssets' }" @click="sortBy('pctNetAssets')">
                                    Percent of Net Assets
                                </button>
                                <i
                                    v-show="sortByLabel === 'pctNetAssets'"
                                    class="icon"
                                    :class="reverse ? 'icon-down-carrot' : 'icon-up-carrot'"
                                />
                            </div>
                        </th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in data" :key="index">
                        <td v-if="row._containsHoldings == '1'">
                            <a
                                :href="row._holdingQuotronSymbol !== '--' ? retailURL(row._holdingQuotronSymbol.toLowerCase()) :
                                afisURL(row._holdingClassSymbol, row._holdingURLName)"
                                class="category-link"
                                target="_blank"
                            >
                                {{ row._holdingsName }}
                            </a>
                        </td>
                        <td v-else>
                            {{ row._holdingsName }}
                        </td>
                        <td>
                            {{ row._assetType }}
                        </td>
                        <td>
                            {{ row._shares }}
                        </td>
                        <td>
                            {{ row._marketValue }}
                        </td>
                        <td>
                            {{ row._pctNetAssets }}
                        </td>
                        <td />
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-nav">
            <div
                :class="getFirstRow > 0 ? '' : 'hidden-buttons'"
                class="nav-buttons"
            >
                <button class="start-end-button" @click="paginationNav('first')">
                    <i class="icon icon-left-carrot" />
                    <i class="icon icon-left-carrot" />
                </button>
                <button class="prev-next-button" @click="paginationNav('prev')">
                    <i class="icon icon-left-carrot" />
                </button>
            </div>
            <span class="paging-info">
                <span v-show="getTotalNumberOfResults > getNumberOfResultsRequested">
                    {{ getSelectedFilter }} Holdings: {{ getFirstRow + 1 }} - {{ isAtHighestEnd(getFirstRow, getNumberOfResultsRequested) }} of {{ getTotalNumberOfResults }}
                </span>
                <span v-show="getTotalNumberOfResults <= getNumberOfResultsRequested && dataLength > 0">
                    {{ getSelectedFilter }} Holdings: 1 - {{ dataLength }} of {{ getTotalNumberOfResults }}
                </span>
                <span v-show="holdingsMetaData.totalFilterCount === 0">
                    {{ getSelectedFilter }} Holdings: 0 - 0 of 0
                </span>
            </span>
            <div
                :class="getFirstRow + getNumberOfResultsRequested < getTotalNumberOfResults ? '' : 'hidden-buttons'"
                class="nav-buttons"
            >
                <button class="prev-next-button" @click="paginationNav('next')">
                    <i class="icon icon-right-carrot" />
                </button>
                <button class="start-end-button" @click="paginationNav('last')">
                    <i class="icon icon-right-carrot" />
                    <i class="icon icon-right-carrot" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'QuarterlyHoldingsTable',
    data() {
        this.data = [];
        return {
            isLoading: true,
            sortByLabel: this.defaultSort,
            data: this.data,
            activeKey: '',
            reverse: true,
            options: {
                sortByLabel: this.defaultSort,
                sortDirection: 'desc',
                pagination: '',
                filterBy: 'All'
            },
            showPreviousButton: false,
            showNextButton: false
        };
    },
    beforeMount() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.resizeBreakpoints();
            });
        });
    },
    mounted() {
        this.setHorizontalScrollOnTable();
    },
    destroyed() {
        slider.removeEventListener('mousedown', mouseDown);
        document.removeEventListener('mouseup', mouseUp);
        document.removeEventListener('mousemove', mouseMove);
    },
    props: ['selectedfilter', 'defaultSort', 'holdingsData', 'holdingsMetaData', 'firstRow', 'numberOfResultsRequested', 'stagingFlag'],
    computed: {
        dataLength() {
            let val = this.holdingsData && Array.isArray(this.holdingsData) && this.holdingsData.length || 0;
            return val
        },
        getSelectedFilter() {
            let val;
            if (this.selectedfilter === 'Cash & Equivalents') val = 'Short Term'
            else val = this.selectedfilter || '';
            return val;
        },
        getFirstRow() {
            return this.firstRow || 0;
        },
        getNumberOfResultsRequested() {
            return this.numberOfResultsRequested || 0;
        },
        getTotalNumberOfResults() {
            return this.holdingsMetaData && this.holdingsMetaData.totalFilterCount || 0;
        },
        audience() {
            return this.getAudience;
        }
    },
    methods: {
        setHorizontalScrollOnTable() {
            const slider = document.querySelector('#table-wrapper');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', function mouseDown(e) {
                e.preventDefault();
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            document.addEventListener('mouseup', function mouseUp() {
                isDown = false;
            });
            document.addEventListener('mousemove', function mouseMove(e) {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX);
                slider.scrollLeft = scrollLeft - walk;
            });
        },
        isAtHighestEnd(n, iterator) {
            return ((n + iterator) >= this.getTotalNumberOfResults) ?
                this.getTotalNumberOfResults :
                n + iterator;
        },
        sortBy(value) {
            if (this.options.sortByLabel === value) {
                if (this.options.sortDirection === 'desc') {
                    this.options.sortDirection = 'asc';
                    this.reverse = false;
                } else {
                    this.options.sortDirection = 'desc';
                    this.reverse = true;
                }
            } else {
                if (value === 'holdings') {
                    this.options.sortDirection = 'asc';
                    this.reverse = false;
                } else {
                    this.options.sortDirection = 'desc';
                    this.reverse = true;
                }
            }
            this.options = Object.assign({}, this.options, { sortByLabel: value });
            this.sortByLabel = value;
            this.emitValuesToParent();
        },
        paginationNav(value) {
            this.options.pagination = value;
            this.emitValuesToParent();
        },
        emitValuesToParent() {
            this.isLoading = true;
            this.$emit('options-update', { ...this.options });
            this.options.pagination = '';
        },
        retailURL(symbol) {
            let link = "";
            let host = window.location.host;
            let isNonIntegrated = this.isNonIntegratedEnv(host);

            if (isNonIntegrated) {
                if (host.indexOf('markitondemand') > -1) {
                    link = "https://capitalgroup.wallst.com/americanfunds/" + this.audience + "/investments/quarterlyholdings/" + symbol;
                } else {
                    let stagingUrl = "capitalgroup.wsodqa.com";
                    switch (this.stagingFlag && this.stagingFlag.toUpperCase()) {
                        case 'UAT1':
                            stagingUrl = "capitalgroup.wsodqa.com";
                            break;
                        case 'UAT2':
                            stagingUrl = "capitalgroup-a2.wsodqa.com";
                            break;
                        case 'UAT3':
                            stagingUrl = "capitalgroup-a3.wsodqa.com";
                            break;
                        case 'UAT4':
                            stagingUrl = "capitalgroup-a4.wsodqa.com";
                            break;
                        default:
                            stagingUrl = "capitalgroup-a3.wsodqa.com";
                    }
                    link = "https://" + stagingUrl + "/americanfunds/" + this.audience + "/investments/quarterlyholdings/" + symbol;
                }
            } else {
                if (host.indexOf('stg.capitalgroup.com') > -1) {
                    link = "https://www.stg.capitalgroup.com/" + this.audience + "/investments/quarterlyholdings/" + symbol;
                } else {
                    link = "https://www.capitalgroup.com/" + this.audience + "/investments/quarterlyholdings/" + symbol;
                }
            }

            return link;
        },
        afisURL(classSymbol, holdingUrl) {
            let link = "";
            let isNonIntegrated = this.isNonIntegratedEnv(window.location.host);
            let href = window.location.href;
            let url = href.substring(0, href.lastIndexOf('/'));

            if (isNonIntegrated) {
                link = url + "/" + classSymbol;
            } else {
                link = url + "/" + holdingUrl + ".htm";
            }

            return link;
        }
    },
    watch: {
        defaultSort: {
            immediate: true,
            handler(val) {
                this.options.sortByLabel = val;
            }
        },
        selectedfilter: {
            immediate: true,
            handler(val) {
                if (this.options.filterBy !== val) {
                    this.options.filterBy = val;
                    this.options.pagination = 'first';
                    this.emitValuesToParent();
                }
            }
        },
        holdingsData: {
            immediate: true,
            handler(val, oldVal) {
                this.isLoading = false;
                this.data = val;

                if (this.holdingsMetaData.firstRecord > 1) {
                    this.showPreviousButton = true;
                } else {
                    this.showPreviousButton = false;
                }

                if (this.holdingsMetaData.lastRecord < this.holdingsMetaData.totalCount) {
                    this.showNextButton = true;
                } else {
                    this.showNextButton = false;
                }
            }
        }
    }
};
</script>
<style lang="less">
@import '../../assets/css/variables';

#holdings-table {
    .table-nav {
        display: flex;
        display: -webkit-flex;
        background-color: #f5f5f5;
        border-top: solid 1px #d4d4d4;
        border-bottom: 1px solid #d4d4d4;
        padding: 10px 5px;

        .nav-buttons {
            min-width: fit-content;

            button {
                width: 33px;
                height: 26px;
                background-color: #fff;
                color: #52bdec;
                cursor: pointer;
                margin: 0 5px;
                border-radius: 3px;
                border: 1px solid #d4d4d4;
                -o-border-image: initial;
                border-image: initial;
                font-weight: bold;
                line-height: 0;
                font-size: 12px;
                position: relative;

                .icon {
                    position: absolute;
                    top: 6px;

                    &:nth-of-type(1) {
                        left: 4px;
                    }

                    &:nth-of-type(2) {
                        left: 14px;
                    }
                }

                &.prev-next-button {
                    width: 24px;
                }
            }

            &.hidden-buttons {
                visibility: hidden;
            }
        }

        .paging-info {
            display: block;
            margin-left: auto;
            margin-right: auto;
            line-height: 25px;

            span {
                font-family: @avenir-regular;
            }
        }
    }

    #table-wrapper {
        width: 100%;
        position: relative;
        margin: auto;
        overflow-x: scroll;

        &::-webkit-scrollbar {
            display: none;
        }

        .icon {
            font-size: 17px;
            transform: scale(0.6, 0.7);
            font-weight: bold;
        }

        #quarterly-holdings-loading-gif {
            background: url('../../assets/img/loading.gif') no-repeat center center;
            background-size: auto;
            height: 100px;
            width: 100%;
            position: absolute;
            top: 100px;
            left: 0;
            z-index: 1;
        }
    }

    table {
        &.loading {
            opacity: 0.5;
        }

        table-layout: fixed;
        border-collapse: collapse;

        .button-container {
            display: flex;

            button {
                text-align: right;
                color: #1d5799;
                border: none;
                background-color: @transparent;
                margin-left: auto;

                &.activeSort {
                    color: #000;
                }
            }

            .arrow {
                font-size: 20px;
                display: inline-block;
                transform: translateY(3px);
            }

            .arrow.arrow-down {
                transform: rotate(180deg) translateY(3px);
            }
        }

        thead {
            tr {
                th {
                    vertical-align: bottom;
                    border-bottom: 1px solid rgb(212, 212, 212);
                    padding: 10px;
                    font-size: 14px;
                    background-color: #f5f5f5;
                    color: gray;
                    font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;

                    &:nth-last-of-type(2) {
                        padding-right: 5px;
                    }

                    &:last-of-type {
                        width: 0px;
                    }

                    &:first-of-type {
                        z-index: 2;

                        .button-container {
                            button {
                                margin-left: 0;
                            }

                            .arrow {
                                margin-right: auto;
                            }
                        }
                    }
                }

                th:nth-child(1) {
                    width: 250px;
                }
            }
        }

        tbody {
            tr {
                height: 55px; //height works the same as min height if the content is too great to be contained
                background-color: white;

                &:nth-child(odd) {
                    background-color: #f9f9f9;
                }

                td {
                    font-size: 14px;
                    padding: 10px;
                    color: #333;
                    font-family: "AvenirNextLTW01-Regular", Arial, sans-serif;

                    &.center-text {
                        text-align: center;
                    }

                    &:nth-child(3),
                    &:nth-child(4),
                    &:nth-child(5) {
                        text-align: right;
                    }

                    &:nth-last-of-type(2) {
                        padding-right: 5px;
                    }

                    &:last-of-type {
                        width: 0px;
                    }
                }
            }
        }
    }
}

.left-cell-scroll-border() {
    position: sticky;
    left: 0;
    border-right: 8px solid #d4d4d4;
    border-image-width: 0 8px 0px 0;
    border-image-source: linear-gradient(90deg, transparent 75%, rgba(0, 0, 0, 0.3) 75%, transparent);
    background-color: #f5f5f5;
    border-image-outset: 0 8px 0px 0;
    border-image-slice: 25%;
    background-origin: inherit repeat;
}

.right-cell-scroll-border() {
    position: sticky;
    right: 0;
    padding: 0;
    border-width: 0 0 0 8px;
    border-style: solid;
    border-image-width: 0 0 0 8px;
    border-image-source: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.3) 28%, transparent);
    border-image-outset: 0 0 0 0px;
    border-image-slice: 30%;
    background-origin: inherit repeat;
    width: 1px;
}

@media (max-width: 996px) {
    #holdings-table.AFIS-table {
        #table-wrapper {
            table {
                width: 938px; //the table locks its width (which took into account the padding/margin of all parent elements)
                border-collapse: inherit;

                tbody tr {
                    td {
                        font-family: "AvenirNextLTW01-Condens 721299", Arial, sans-serif;
                    }

                    td:first-of-type {
                        .left-cell-scroll-border();
                    }

                    td:last-of-type {
                        .right-cell-scroll-border();
                    }

                    td:nth-last-of-type(2) {
                        padding-right: 12px;
                    }

                    &:nth-child(odd) {
                        td:first-of-type {
                            background-color: #f9f9f9;
                        }
                    }

                    &:nth-child(even) {
                        td:first-of-type {
                            background-color: #ffffff;
                        }
                    }
                }

                thead tr th {
                    &:nth-last-of-type(2) {
                        padding-right: 12px;
                    }

                    &:first-of-type {
                        .left-cell-scroll-border();
                        border-image-source: linear-gradient(90deg, #d4d4d4 75%, rgba(0, 0, 0, .3) 0, transparent);
                        border-image-width: 0 8px 1px 0;
                        border-image-outset: 0 8px 0px 0;
                    }

                    &:last-of-type {
                        .right-cell-scroll-border();
                    }
                }
            }
        }
    }
}

@media (max-width: 480px) {
    #holdings-table table thead tr th:nth-child(1) {
        width: 52vw;
    }
}
</style>